/**
 * Simplified Monster Quiz JavaScript
 * Self-contained version that doesn't depend on external files
 */

console.log('Monster Quiz JavaScript loaded');

// Make functions globally available
window.addToCartSimple = addToCartSimple;

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, initializing quiz...');
  
  const quizContainer = document.getElementById('monster-quiz');
  if (!quizContainer) {
    console.error('Quiz container not found');
    return;
  }

  // Initialize the quiz
  initMonsterQuiz();
});

/**
 * Simple add to cart function - Define globally first
 */
async function addToCartSimple(variantId) {
  console.log('Adding to cart:', variantId);
  
  try {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      // Show success message
      const messageEl = document.createElement('div');
      messageEl.textContent = 'Added to cart! 🎉';
      messageEl.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #28a745;
        color: white;
        padding: 15px 20px;
        border-radius: 8px;
        z-index: 1000;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      `;
      
      document.body.appendChild(messageEl);
      
      // Update cart if your theme has a cart refresh function
      if (window.theme?.cart?.refresh) {
        window.theme.cart.refresh();
      }
      
      setTimeout(() => {
        messageEl.remove();
      }, 3000);
    } else {
      throw new Error('Failed to add to cart');
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    
    // Show error message
    const messageEl = document.createElement('div');
    messageEl.textContent = 'Error adding to cart. Please try again.';
    messageEl.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #dc3545;
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      z-index: 1000;
    `;
    
    document.body.appendChild(messageEl);
    setTimeout(() => messageEl.remove(), 3000);
  }
}

/**
 * Show products for monster - Define globally
 */
async function showProductsForMonster(monster) {
  console.log('Loading products for monster:', monster);
  
  // Find the product carousel container
  const carouselContainer = document.querySelector('.product-carousel');
  if (!carouselContainer) return;

  // Monster-specific product tags and colors
  const monsterTags = {
    willow: 'willow,veggie-friendly,picky-eater',
    rocco: 'rocco,texture-friendly,sensory-safe', 
    zander: 'zander,bold-flavors,adventurous',
    zuri: 'zuri,familiar,repeater-friendly',
    poppy: 'poppy,snack-sized,portable'
  };

  const monsterColors = {
    willow: '#FA6D9B',
    rocco: '#BD77CE',
    zander: '#5CCD59', 
    zuri: '#FF7546',
    poppy: '#24B5E0'
  };

  // Add loading state to carousel
  const existingTitle = carouselContainer.querySelector('.carousel-title');
  if (existingTitle) {
    existingTitle.insertAdjacentHTML('afterend', `
      <div class="products-loading" style="text-align: center; padding: 20px; color: #FFF8E7;">
        <div style="font-size: 1.5rem; margin-bottom: 10px;">🍽️</div>
        <p>Finding perfect meals for ${monster}...</p>
      </div>
    `);
  }

  let products = [];

  try {
    // Try method 1: Products API from main collection
    console.log('Trying method 1: Main collection products API');
    const collectionResponse = await fetch('/collections/all/products.json?limit=20');
    
    if (collectionResponse.ok) {
      const collectionData = await collectionResponse.json();
      console.log('Collection API response:', collectionData);
      
      if (collectionData.products && collectionData.products.length > 0) {
        // Filter by monster tags if available
        const tags = monsterTags[monster] ? monsterTags[monster].split(',') : [monster];
        const filteredProducts = collectionData.products.filter(product => {
          return product.tags && product.tags.some(tag => 
            tags.some(monsterTag => tag.toLowerCase().includes(monsterTag.toLowerCase()))
          );
        });
        
        if (filteredProducts.length > 0) {
          products = filteredProducts.slice(0, 4);
          console.log('Found filtered products:', products.length);
        } else {
          // If no filtered products, take first 4 products
          products = collectionData.products.slice(0, 4);
          console.log('Using first 4 products as fallback');
        }
      }
    }
  } catch (error) {
    console.log('Method 1 failed:', error);
  }

  // Try method 2: Search API if first method failed
  if (products.length === 0) {
    try {
      console.log('Trying method 2: Search API');
      const tags = monsterTags[monster] || monster;
      const searchResponse = await fetch(`/search?q=tag:${tags.split(',')[0]}&type=product&view=json`);
      
      if (searchResponse.ok) {
        const searchData = await searchResponse.json();
        if (searchData.results) {
          products = searchData.results.slice(0, 4);
          console.log('Found products via search:', products.length);
        }
      }
    } catch (error) {
      console.log('Method 2 failed:', error);
    }
  }

  // Try method 3: Alternative search endpoint
  if (products.length === 0) {
    try {
      console.log('Trying method 3: Alternative search');
      const searchResponse = await fetch(`/search.json?q=${monster}&type=product`);
      
      if (searchResponse.ok) {
        const searchData = await searchResponse.json();
        if (searchData.results) {
          products = searchData.results.slice(0, 4);
          console.log('Found products via alternative search:', products.length);
        }
      }
    } catch (error) {
      console.log('Method 3 failed:', error);
    }
  }

  // Remove loading state
  const loadingDiv = carouselContainer.querySelector('.products-loading');
  if (loadingDiv) loadingDiv.remove();

  if (products.length === 0) {
    console.log('No products found, showing message');
    // No products found - show a nice message
    const shopBtn = carouselContainer.querySelector('.shop-monster-btn');
    if (shopBtn) {
      shopBtn.insertAdjacentHTML('afterend', `
        <div style="text-align: center; padding: 20px; color: #FFF8E7;">
          <p>🍽️ We're building the perfect collection for ${monster}!</p>
          <p style="font-size: 0.9rem; opacity: 0.8;">In the meantime, check out our full collection above.</p>
        </div>
      `);
    }
    return;
  }

  console.log('Displaying', products.length, 'products');

  // Generate product cards HTML
  const productCards = products.map(product => {
    const price = product.price ? (product.price / 100).toFixed(2) : '0.00';
    const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
    const image = product.featured_image || (product.images && product.images[0]) || '/assets/placeholder.png';
    const isOnSale = comparePrice && parseFloat(comparePrice) > parseFloat(price);
    const variantId = product.variants && product.variants[0] ? product.variants[0].id : product.id;
    
    return `
      <div class="simple-product-card" style="background: rgba(255,248,231,0.95); border-radius: 12px; padding: 15px; border: 2px solid ${monsterColors[monster]};">
        <div style="position: relative; margin-bottom: 12px;">
          <img src="${image}" alt="${product.title}" style="width: 100%; height: 180px; object-fit: cover; border-radius: 8px;">
          ${isOnSale ? '<span style="position: absolute; top: 8px; right: 8px; background: #EF5669; color: white; padding: 4px 8px; border-radius: 4px; font-size: 11px; font-weight: 600;">Sale</span>' : ''}
          <div style="position: absolute; bottom: 8px; left: 8px; background: ${monsterColors[monster]}; color: white; padding: 4px 8px; border-radius: 4px; font-size: 10px; font-weight: 600;">Perfect for ${monster}!</div>
        </div>
        <h4 style="color: #0476BF; font-size: 1.1rem; margin-bottom: 8px; line-height: 1.3;">${product.title}</h4>
        <div style="margin-bottom: 10px;">
          ${isOnSale ? `<span style="text-decoration: line-through; color: #999; margin-right: 8px;">${comparePrice}</span>` : ''}
          <span style="color: #EF5669; font-weight: 700; font-size: 1.1rem;">${price}</span>
        </div>
        <div style="display: flex; flex-direction: column; gap: 8px;">
          <button onclick="addToCartSimple('${variantId}')" 
                  style="width: 100%; background: ${monsterColors[monster]}; color: white; border: none; padding: 12px; border-radius: 8px; font-weight: 600; cursor: pointer; transition: all 0.3s ease;">
            Add to Cart
          </button>
          <a href="${product.url || `/products/${product.handle}`}" 
             style="display: block; text-align: center; padding: 8px; border: 2px solid #0476BF; border-radius: 8px; color: #0476BF; text-decoration: none; font-weight: 600;">
            View Details
          </a>
        </div>
      </div>
    `;
  }).join('');

  // Add products to carousel (after the shop button)
  const shopBtn = carouselContainer.querySelector('.shop-monster-btn');
  if (shopBtn && shopBtn.parentElement) {
    shopBtn.parentElement.insertAdjacentHTML('afterend', `
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px; margin: 20px 0;">
        ${productCards}
      </div>
    `);
  }
}

function initMonsterQuiz() {
  console.log('Initializing Monster Quiz...');
  
  // Quiz state
  let currentQuestion = 1;
  let totalQuestions = 5;
  let answers = [];
  let contactInfo = { name: '', email: '' };
  let isProcessingAnswer = false; // Prevent double-clicks

  // Get elements
  const startBtn = document.querySelector('.start-quiz-btn');
  const contactForm = document.getElementById('quiz-contact-form');
  const quizContent = document.querySelector('.quiz-content');
  const quizIntro = document.querySelector('.quiz-intro');
  const quizQuestionsEl = document.querySelector('.quiz-questions');
  const questionCounter = document.querySelector('.question-counter');
  const progressBar = document.querySelector('.quiz-progress-bar');
  const resultsContainer = document.querySelector('.quiz-results');
  const contactFormContainer = document.querySelector('.quiz-contact-form-container');

  console.log('Elements found:', {
    startBtn: !!startBtn,
    contactForm: !!contactForm,
    quizContent: !!quizContent,
    quizIntro: !!quizIntro
  });

  // Create question slides
  createQuestionSlides();

  // Event listeners
  if (startBtn) {
    startBtn.addEventListener('click', handleStartQuiz);
    console.log('Start button event listener added');
  }
  
  if (contactForm) {
    contactForm.addEventListener('submit', handleContactFormSubmit);
  }
  
  document.addEventListener('click', handleQuizButtonClicks);

  /**
   * Handles the start quiz button click
   */
  function handleStartQuiz() {
    console.log('Start quiz button clicked');
    
    if (quizIntro && quizContent) {
      quizIntro.style.opacity = '0';
      setTimeout(() => {
        quizIntro.style.display = 'none';
        quizContent.style.display = 'block';
        quizContent.style.opacity = '1';
      }, 300);
    }
  }

  /**
   * Creates the question slides
   */
  function createQuestionSlides() {
    console.log('Creating question slides...');
    
    if (!quizQuestionsEl) {
      console.error('Quiz questions element not found');
      return;
    }

    // Clear existing content
    quizQuestionsEl.innerHTML = '';

    quizQuestions.forEach((question, index) => {
      const questionNumber = index + 1;
      const isActive = questionNumber === 1;
      
      console.log('Creating question', questionNumber, ':', question.question);
      
      const questionSlide = document.createElement('div');
      questionSlide.className = 'question-slide';
      questionSlide.dataset.question = questionNumber;
      questionSlide.style.display = isActive ? 'block' : 'none';
      
      const questionTitle = document.createElement('h3');
      questionTitle.textContent = question.question;
      questionSlide.appendChild(questionTitle);
      
      const answersContainer = document.createElement('div');
      answersContainer.className = 'answers';
      
      question.answers.forEach(answer => {
        const answerButton = document.createElement('button');
        answerButton.className = 'answer-btn';
        answerButton.dataset.monster = answer.monster;
        answerButton.textContent = answer.text;
        answersContainer.appendChild(answerButton);
      });
      
      questionSlide.appendChild(answersContainer);
      quizQuestionsEl.appendChild(questionSlide);
    });
    
    console.log('Question slides created:', quizQuestionsEl.children.length);
    
    // Debug: Log all created slides
    document.querySelectorAll('.question-slide').forEach((slide, index) => {
      console.log('Slide', index + 1, 'data-question:', slide.dataset.question, 'display:', slide.style.display);
    });
  }

  /**
   * Handles the contact form submission
   */
  function handleContactFormSubmit(e) {
    e.preventDefault();
    console.log('Contact form submitted');
    
    // Store contact info
    contactInfo = {
      name: document.getElementById('parent-name').value,
      email: document.getElementById('parent-email').value
    };

    // Hide contact form, show results
    if (contactFormContainer) {
      contactFormContainer.style.display = 'none';
    }
    calculateResults();
  }

  /**
   * Handles clicks on quiz buttons
   */
  function handleQuizButtonClicks(e) {
    // Handle answer button clicks
    if (e.target.classList.contains('answer-btn')) {
      e.preventDefault();
      e.stopPropagation();
      
      // Prevent double-clicks
      if (isProcessingAnswer) {
        console.log('Already processing answer, ignoring duplicate click');
        return;
      }
      
      isProcessingAnswer = true;
      
      console.log('Answer clicked:', e.target.dataset.monster, 'Current question:', currentQuestion);
      
      const monster = e.target.dataset.monster;
      answers.push(monster);
      
      // Remove selected class from all buttons in this question
      const buttons = e.target.closest('.answers').querySelectorAll('.answer-btn');
      buttons.forEach(btn => {
        btn.classList.remove('selected', 'willow', 'rocco', 'zander', 'zuri', 'poppy');
        btn.disabled = true; // Disable all buttons to prevent multiple clicks
      });
      
      // Add selected class and monster class to clicked button
      e.target.classList.add('selected', monster);
      
      console.log('Answers so far:', answers);
      
      // Wait a moment before showing next question
      setTimeout(() => {
        showNextQuestion();
        // Re-enable buttons for next question after a delay
        setTimeout(() => {
          isProcessingAnswer = false;
        }, 100);
      }, 800);
      
      return false;
    }
    
    // Handle restart button clicks
    if (e.target.classList.contains('restart-quiz-btn')) {
      restartQuiz();
    }

    // Handle add to cart button clicks
    if (e.target.classList.contains('add-to-cart-btn')) {
      const variantId = e.target.dataset.variantId;
      addToCart(variantId);
    }
  }

  /**
   * Updates the progress bar and counter
   */
  function updateProgress() {
    const progress = ((currentQuestion - 1) / totalQuestions) * 100;
    
    if (progressBar) {
      progressBar.style.width = `${progress}%`;
    }
    
    if (questionCounter) {
      questionCounter.textContent = `Question ${currentQuestion} of ${totalQuestions}`;
    }
  }

  /**
   * Shows the next question or contact form
   */
  function showNextQuestion() {
    console.log('Showing next question, current:', currentQuestion, 'total questions:', totalQuestions);
    
    const currentSlide = document.querySelector(`.question-slide[data-question="${currentQuestion}"]`);
    
    if (currentQuestion < totalQuestions) {
      // Hide current slide
      if (currentSlide) {
        currentSlide.style.display = 'none';
      }
      
      // Move to next question
      currentQuestion++;
      
      // Show next slide
      const nextSlide = document.querySelector(`.question-slide[data-question="${currentQuestion}"]`);
      if (nextSlide) {
        nextSlide.style.display = 'block';
        console.log('Showing question:', currentQuestion);
        
        // Re-enable buttons for the new question
        const nextButtons = nextSlide.querySelectorAll('.answer-btn');
        nextButtons.forEach(btn => {
          btn.disabled = false;
        });
      } else {
        console.error('Next slide not found for question:', currentQuestion);
      }
      
      updateProgress();
    } else {
      // Quiz complete - show contact form
      console.log('Quiz complete, showing contact form');
      
      if (currentSlide) currentSlide.style.display = 'none';
      if (contactFormContainer) {
        contactFormContainer.style.display = 'block';
      }
    }
  }

  /**
   * Calculate and display results
   */
  function calculateResults() {
    console.log('Calculating results...', answers);
    
    if (!resultsContainer) {
      console.error('Results container not found');
      return;
    }

    // Show loading
    resultsContainer.style.display = 'block';
    resultsContainer.innerHTML = '<div class="quiz-loader"><div class="loader-spinner"></div><p>Analyzing responses...</p></div>';

    setTimeout(() => {
      try {
        // Calculate dominant and secondary monster
        const { dominantMonster, secondaryMonster } = calculateMonsterResults(answers);
        console.log('Results:', { dominantMonster, secondaryMonster });
        
        // Format results HTML
        const resultsHTML = formatResults(dominantMonster, secondaryMonster);
        
        // Save results
        saveQuizResults(contactInfo, answers, dominantMonster, secondaryMonster);
        
        // Show results
        resultsContainer.innerHTML = resultsHTML;
        
        // Show congratulations banner
        const banner = document.getElementById('congratulations-banner');
        if (banner) {
          banner.style.display = 'block';
        }
        
        // Load products after results are displayed
        setTimeout(() => {
          showProductsForMonster(dominantMonster.toLowerCase());
        }, 500);
        
      } catch (error) {
        console.error('Error calculating results:', error);
        resultsContainer.innerHTML = `
          <div class="quiz-error">
            <h3>Oops! Something went wrong</h3>
            <p>Please try again later.</p>
            <button class="restart-quiz-btn">Try Again</button>
          </div>
        `;
      }
    }, 1000);
  }

  /**
   * Calculate monster results
   */
  function calculateMonsterResults(answers) {
    const monsterCounts = {};
    
    // Count occurrences
    answers.forEach(monster => {
      monsterCounts[monster] = (monsterCounts[monster] || 0) + 1;
    });
    
    // Sort by count
    const sortedMonsters = Object.keys(monsterCounts).sort((a, b) => {
      return monsterCounts[b] - monsterCounts[a];
    });
    
    return {
      dominantMonster: sortedMonsters[0],
      secondaryMonster: sortedMonsters[1] || null
    };
  }

  /**
   * Format results HTML
   */
  function formatResults(dominantMonster, secondaryMonster) {
    let output = '<div class="quiz-results-container">';
    output += `<h2 class="results-title">${QUIZ_CONSTANTS.RESULTS_TITLE}</h2>`;
    
    // Primary monster result
    if (quizMonsters[dominantMonster]) {
      output += formatMonsterCard(quizMonsters[dominantMonster], true);
    }

    // Secondary monster result
    if (secondaryMonster && quizMonsters[secondaryMonster]) {
      output += formatMonsterCard(quizMonsters[secondaryMonster], false);
    }

    output += `<button class="restart-quiz-btn">${QUIZ_CONSTANTS.RESTART_BUTTON_TEXT}</button>`;
    output += '</div>';

    return output;
  }

  /**
   * Format monster card
   */
  function formatMonsterCard(monsterData, isPrimary = false) {
    let output = `<div class="monster-result${isPrimary ? ' primary' : ''}">`;
    
    // Monster header
    output += '<div class="monster-header">';
    output += `<img src="${monsterData.icon}" alt="${monsterData.name}" class="monster-icon">`;
    output += `<h2 class="monster-name">${monsterData.name}</h2>`;
    output += `<h3 class="monster-title">${monsterData.title}</h3>`;
    output += `<p class="monster-tagline">"${monsterData.tagline}"</p>`;
    output += '</div>';

    // Monster description
    output += `<p class="monster-description">${monsterData.description}</p>`;

    // Help section
    output += '<div class="help-section">';
    output += `<h4>How YOU can help ${monsterData.name}</h4>`;
    output += '<ul class="help-tips">';
    monsterData.help_tips.forEach(tip => {
      output += `<li>${tip}</li>`;
    });
    output += '</ul>';
    
    if (monsterData.pro_tip) {
      output += `<p style="font-style: italic; color: #EF5669; margin-top: 15px;"><strong>Pro tip:</strong> ${monsterData.pro_tip}</p>`;
    }
    output += '</div>';

    // Product carousel
    output += createProductCarousel(monsterData.name);
    
    output += '</div>';

    return output;
  }

  /**
   * Create product carousel
   */
  function createProductCarousel(monsterName) {
    let output = '<div class="product-carousel">';
    
    // Determine carousel title and shop URL
    let carouselTitle = '';
    let shopUrl = '';
    
    switch(monsterName.toLowerCase()) {
      case 'willow':
        carouselTitle = 'Browse Willow-friendly foods';
        shopUrl = 'https://themonsterstable.com/collections/all?filter.p.m.custom.monster=gid%3A%2F%2Fshopify%2FMetaobject%2F87716888788';
        break;
      case 'rocco':
        carouselTitle = 'Shop meals for Rocco';
        shopUrl = 'https://themonsterstable.com/collections/all?filter.p.m.custom.monster=gid%3A%2F%2Fshopify%2FMetaobject%2F87716921556';
        break;
      case 'zander':
        carouselTitle = 'Shop meals for Zander';
        shopUrl = 'https://themonsterstable.com/collections/all?filter.p.m.custom.monster=gid%3A%2F%2Fshopify%2FMetaobject%2F87716692180';
        break;
      case 'zuri':
        carouselTitle = 'Browse Zuri-friendly foods';
        shopUrl = 'https://themonsterstable.com/collections/all?filter.p.m.custom.monster=gid%3A%2F%2Fshopify%2FMetaobject%2F87716626644';
        break;
      case 'poppy':
        carouselTitle = 'Shop meals for Poppy';
        shopUrl = 'https://themonsterstable.com/collections/all?filter.p.m.custom.monster=gid%3A%2F%2Fshopify%2FMetaobject%2F87716790484';
        break;
      default:
        carouselTitle = `Shop meals for ${monsterName}`;
        shopUrl = 'https://themonsterstable.com/collections/all';
    }
    
    output += `<h3 class="carousel-title">${carouselTitle}</h3>`;
    
    // Add shop button
    output += `
      <div style="text-align: center; margin-bottom: 30px;">
        <a href="${shopUrl}" class="shop-monster-btn" target="_blank">
          Shop ${monsterName} Products
        </a>
      </div>
    `;
    
    output += '</div>';
    
    return output;
  }

  /**
   * Handle shop button clicks
   */
  function handleShopButtonClick(e) {
    if (e.target.classList.contains('shop-monster-btn')) {
      // Analytics tracking could go here
      console.log('Shop button clicked for:', e.target.textContent);
    }
  }

  // Add shop button click handler to existing event listener
  document.addEventListener('click', function(e) {
    handleQuizButtonClicks(e);
    handleShopButtonClick(e);
  });

  /**
   * Add to cart
   */
  function addToCart(variantId) {
    console.log('Adding to cart:', variantId);
    
    // Show message
    const messageEl = document.createElement('div');
    messageEl.textContent = 'Product added to cart!';
    messageEl.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #4CAF50;
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      z-index: 1000;
    `;
    
    document.body.appendChild(messageEl);
    
    setTimeout(() => {
      messageEl.remove();
    }, 3000);
  }

  /**
   * Save quiz results
   */
  function saveQuizResults(contactInfo, answers, dominantMonster, secondaryMonster) {
    try {
      const result = {
        name: contactInfo.name,
        email: contactInfo.email,
        primary_monster: dominantMonster,
        secondary_monster: secondaryMonster,
        answers: answers,
        created_at: new Date().toISOString()
      };
      
      const existingResults = JSON.parse(localStorage.getItem('monster_quiz_results') || '[]');
      existingResults.push(result);
      localStorage.setItem('monster_quiz_results', JSON.stringify(existingResults));
      
      console.log('Quiz results saved to localStorage');
    } catch (error) {
      console.error('Error saving quiz results:', error);
    }
  }

  /**
   * Restart quiz
   */
  function restartQuiz() {
    console.log('Restarting quiz...');
    
    // Reset state
    currentQuestion = 1;
    answers = [];
    contactInfo = { name: '', email: '' };
    isProcessingAnswer = false; // Reset processing flag
    
    // Hide results and contact form
    if (resultsContainer) resultsContainer.style.display = 'none';
    if (contactFormContainer) contactFormContainer.style.display = 'none';
    if (quizContent) quizContent.style.display = 'none';
    
    // Hide congratulations banner
    const banner = document.getElementById('congratulations-banner');
    if (banner) banner.style.display = 'none';
    
    // Reset form
    if (contactForm) contactForm.reset();
    
    // Reset buttons
    document.querySelectorAll('.answer-btn').forEach(btn => {
      btn.classList.remove('selected', 'willow', 'rocco', 'zander', 'zuri', 'poppy');
      btn.disabled = false; // Re-enable all buttons
    });
    
    // Show first question
    document.querySelectorAll('.question-slide').forEach((slide, index) => {
      slide.style.display = index === 0 ? 'block' : 'none';
    });
    
    // Show intro
    if (quizIntro) {
      quizIntro.style.display = 'block';
      quizIntro.style.opacity = '1';
    }
    
    updateProgress();
  }

  // Initialize progress
  updateProgress();
  
  console.log('Monster Quiz initialized successfully');
}